import React, { useState } from 'react';
import { useEvent, useUnit } from 'effector-react';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { $ModalStore, closeModalEvent } from '@nx-frontend/shared/ui/modal';
import { DeleteProjectionOriginType, DeleteProjectionsSelect } from '@nx-frontend/entities/delete-projections-select';
import { DeleteProjectionOriginPopupPayload, PopupType } from '@nx-frontend/shared/types';

export function DeleteProjectionOriginPopup() {
  const [modalStore] = useUnit([$ModalStore]);
  const [closeModal] = useEvent([closeModalEvent]);

  const modal = modalStore.find((m) => m.content === PopupType.DELETE_PROJECTION_ORIGIN);
  const payload = modal?.payload as DeleteProjectionOriginPopupPayload;
  const menuItemId = payload?.menuItemId;
  const menuItemType = payload?.menuItemType;
  const [deleteType, setDeleteType] = useState(DeleteProjectionOriginType.DELETE_LINKED);

  const submit = () => {
    payload.submit(deleteType === DeleteProjectionOriginType.KEEP_LINKED);
  };

  const handleChange = (value: DeleteProjectionOriginType) => {
    setDeleteType(value);
  };

  return (
    <div>
      {payload && (
        <DeleteProjectionsSelect menuItemId={menuItemId} menuItemType={menuItemType} onChange={handleChange} />
      )}
      <div className="flex gap-5 justify-end mt-7">
        <Button type={ButtonType.STROKED} size={ButtonSize.XL} onClick={() => closeModal()}>
          Cancel
        </Button>
        <Button size={ButtonSize.XL} type={ButtonType.FLAT} onClick={submit}>
          Delete
        </Button>
      </div>
    </div>
  );
}
